import Layout from "components/layout"
import MovieDetail from "features/movies/MovieDetail"

const Detail = () => (
  <Layout>
    <MovieDetail />
  </Layout>
)

export default Detail
